import React, { FC } from "react";

export interface PricesProps {
  className?: string;
  price?: number;
  contentClass?: string;
}

const Prices: FC<PricesProps> = ({
  className = "",
  price = 0,
  contentClass = "py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium text-violet-500",
}) => {
  return (
    <div className={`${className}`}>
      <div
        className={`flex items-center border-2 border-violet-500 rounded-lg ${contentClass}`}
      >
        <span className=" !leading-none">
          {price} DZD
        </span>
      </div>
    </div>
  );
};

export default Prices;
